import * as React from "react";

export interface RadioProps {
    text: string;
}

export interface RadioColumnProps {
    text: string;
    label?: string;
}

export const Radio: React.FunctionComponent<RadioProps> = ({
    text,
}: RadioProps) => {
    return (
        <>
            <div className="radio">
                <input
                    className="input"
                    type="radio"
                    name="radio"
                    value={text}
                    id="radio-mr"
                />
                <label htmlFor="radio-mr">{text}</label>
            </div>
        </>
    );
};

export const RadioColumn: React.FunctionComponent<RadioColumnProps> = ({
    label,
    text,
}: RadioColumnProps) => {
    return (
        <>
            <label className="radio-label">{label}</label>
            <div className="radio-column">
                <Radio text={text} />
            </div>
        </>
    );
};
